import { render, staticRenderFns } from "./FormularioNominaEditar.vue?vue&type=template&id=5c5cbf1b&scoped=true"
import script from "./FormularioNominaEditar.vue?vue&type=script&lang=js"
export * from "./FormularioNominaEditar.vue?vue&type=script&lang=js"
import style0 from "./FormularioNominaEditar.vue?vue&type=style&index=0&id=5c5cbf1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cbf1b",
  null
  
)

export default component.exports